export default "__VITE_ASSET__RMGBIcAz__"